import SuperAgent from 'superagent'
import {api_root} from '@src/index.js'
import {errorHandling, unauthorizedRedirect} from './error.handler.js'
import {getBearerAccessToken} from "./authenticate";

export const treatmentsService = {
  getTreatments,
  getCropState,
  getCropStateForTreatment,
  deleteStats,
  getTreatmentsLastDay,
  getTreatmentDetail,
  download,
};


function deleteStats(treatment_id, callback, reject) {
  return SuperAgent
  .get(api_root + "/treatment/" + treatment_id + "/recalculate_stats")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getTreatments(from, to, device_serial, map_id, per_page, page, callback, reject) {
  return SuperAgent
  .get(api_root + "/treatment/all")
  .query({from})
  .query({to})
  .query({device_serial})
  .query({map_id})
  .query({page})
  .query({per_page})
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getCropState(map_id, map_version, callback, reject) {
  return SuperAgent
  .get(api_root + "/treatment/crop_state")
  .query({map_id})
  .query({map_version})
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getCropStateForTreatment(treatment_id, layer_type, callback, reject) {
  return SuperAgent
  .get(api_root + `/treatment/crop_state/${treatment_id}/${layer_type}`)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}


function getTreatmentDetail(treatment_id, callback, reject) {
  return SuperAgent
  .get(api_root + "/treatment/" + treatment_id + "/detail")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function download(treatment_id, callback, reject) {
  return SuperAgent
  .get(api_root + "/treatment/" + treatment_id + "/download")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const FileSaver = require('file-saver');
    const text = response.text;
    const data = text && JSON.parse(text);
    let blob = new Blob([JSON.stringify(data["result"], null, 4)], {type: "text/plain;charset=utf-8"});
    FileSaver.saveAs(blob, treatment_id + ".json")
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getTreatmentsLastDay(callback, reject) {
  return SuperAgent
  .get(api_root + "/treatment/last_day")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}
